import View from "../framework/view";
import jQuery from "jquery";
import {Order} from "../bo/order";
import {isDelivery} from "../misc/orders";
import {Map_, Visualization_} from "../google/apis";
import {west_row_botanica} from "./map";

export class HeatmapView extends View {

    static classname = "heatmap-view";

    private orders: Order[] | undefined;

    private map? : any;

    private cachedElt: JQuery<HTMLElement> | undefined = undefined;

    constructor() {
        super(HeatmapView.classname);
    }

    setOrders(orders: Order[]) {
        this.orders = orders;
        this.cachedElt = undefined;
        this.update();
    }

    protected render0(): JQuery<HTMLElement> {

        if (this.cachedElt) {
            return this.cachedElt;
        }

        const out = jQuery("<div style='height: 100%; min-height: 600px; width: 100%; margin-left: auto; margin-right: auto;'></div>");

        this.afterUpdate(() => {

            const elt = this.elt()[0];

            if (! elt || this.cachedElt) {
                return;
            }

            Promise.all([Map_, Visualization_]).then(([Map, Visualization]) => {

                const orders = this.orders && this.orders.filter((order) => {
                    const address = isDelivery(order);
                    return address && address.geocoded;
                }) || [];

                const toPosition : (order: Order) => { lat: number, lng: number } = (order) => {
                    const address = isDelivery(order);
                    const position = { lat: address.lat, lng: address.lng };
                    return position;
                }

                // @ts-ignore
                const map = new Map(elt, {
                    center: west_row_botanica,
                    zoom: 11,
                });

                const bounds = new google.maps.LatLngBounds();

                const heatmapData : google.maps.LatLng[] = [];

                for (const order of orders) {

                    const address = isDelivery(order);
                    if (address && address.geocoded) {
                        const position = { lat: address.lat, lng: address.lng };
                        bounds.extend(position);
                        heatmapData.push(new google.maps.LatLng(position));
                    }

                }
                this.map = map;

                const heatmap = new google.maps.visualization.HeatmapLayer({
                    data: heatmapData,
                    radius: 20,
                });
                heatmap.setMap(map);

                console.log("heatmap with " + heatmapData.length + " data points");

            }).catch((err: any) => {
                console.error("Map failed", err);
            });

            this.cachedElt = out;
        });

        return out;
    }

}
